<script>
export default {
  computed: {
    breadcrumbs: function() {
      let params = this.$route.params;
      let bc = [];
      bc.push({
        text: "psos",
        href: this.$router.resolve({ name: "home" }).href
      });
      if ("job_id" in params) {
        bc.push({
          text: params.job_id,
          href: this.$router.resolve({
            name: "job-overview",
            params: { job_id: params.job_id }
          }).href
        });
      }
      if ("job_id" in params && "seq_id" in params) {
        bc.push({
          text: params.seq_id,
          href: this.$router.resolve({
            name: "seq-details",
            params: { job_id: params.job_id, seq_id: params.seq_id }
          }).href
        });
      }
      if (this.$route.name === "features-view") {
        bc.push({
          text: "Features",
          href: this.$router.resolve(this.$route).href
        });
      }
      if (this.$route.name === "homologies-view") {
        bc.push({
          text: "Homologies",
          href: this.$router.resolve(this.$route).href
        });
      }
      if (this.$route.name === "references-view") {
        bc.push({
          text: "References",
          href: this.$router.resolve(this.$route).href
        });
      }
      if (this.$route.name === "wordcloud-view") {
        bc.push({
          text: "Wordcloud",
          href: this.$router.resolve(this.$route).href
        });
      }
      return bc;
    }
  }
};
</script>
